const MODULE = document.querySelectorAll('[data-module="faq"]');

class Faq {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach(component => {
            const faqs = component.querySelectorAll('.faq');

            if (!faqs) return;

            faqs.forEach((faq) => {
                faq.addEventListener('click', (e) => {
                    if (e.target.closest('a')) return;
                    
                    if (!faq.classList.contains('active')) {
                        this.removeActiveAllFAQS(component);
                        faq.classList.toggle('active');
                    } else {
                        this.removeActiveAllFAQS(component);
                    }
                })
            })

        });
    }

    removeActiveAllFAQS(component) {
        if (!component) return;

        const faqs = component.querySelectorAll('.faq');



        if (!faqs) return;
        faqs.forEach((faq) => {
            faq.classList.remove('active');
        })
    }
}

(() => {
    if (MODULE) {
        new Faq();
    }
})();

export default Faq;